import Vue from 'vue';

import {
    AlertPlugin,
    BadgePlugin,
    BreadcrumbPlugin,
    ButtonPlugin,
    ButtonGroupPlugin,
    CardPlugin,
    DropdownPlugin,
    FormPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormRadioPlugin,
    FormSelectPlugin,
    FormTextareaPlugin,
    ImagePlugin,
    InputGroupPlugin,
    ListGroupPlugin,
    ModalPlugin,
    NavbarPlugin,
    PaginationPlugin,
    ProgressPlugin,
    SpinnerPlugin,
    TablePlugin,
    ToastPlugin,
    IconsPlugin
} from 'bootstrap-vue';

// 按需加载
Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(BreadcrumbPlugin);
Vue.use(ButtonPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(ImagePlugin);
Vue.use(InputGroupPlugin);
Vue.use(ListGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);
Vue.use(PaginationPlugin);
Vue.use(ProgressPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(ToastPlugin);
Vue.use(IconsPlugin)

// import Alert from './components/alert'
// Vue.use(Alert)

import Confirm from './components/confirm/index'
Vue.use(Confirm)

import Prompt from './components/prompt/index'
Vue.use(Prompt)